export const differenceMinutes = (dateNow, dateCompare) => {
  let diff =(dateCompare.getTime() - dateNow.getTime()) / 1000;
  diff /= 60;
  
  return Math.abs(Math.round(diff));
}
